module.exports = __webpack_public_path__ + "static/media/servicesvirtuallegal.2ba42e10.png";